import React from "react";
import {
  Collapse,
  Icon,
  Row,
  Spin,
  Col,
  Layout,
  message,
} from "antd";
import img from './../../assets/img/At the office-pana 1.png';
import MiCompAPI from "./../../util/api";
import ManageInvoiceForm from "../elements/ManageInvoiceForm";
const { Panel } = Collapse;
const { Content } = Layout;
class Finance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isloading: false
    }
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  SubmitHandler = (data) => {
    this.setState({
      isloading: true
    })
    var url;
    url = data.type === "invoice" ? "PROCESS_INVOICE" : data.type === "payment" ? "PROCESS_PAYMENT" : "MONTHLY_RECONCILE";
    data = {
      IYear: data.IYear,
      IMonth: data.IMonth,
      ILob: 0,
      IClient: data.IClient,
      base64file:data.base64file,
      docName:data.docName
    }
    this.api.invoke(
      url,
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              isloading: false
            })
            message.destroy();
            message.success(data.statusMessage, 3);
            if(url==="PROCESS_PAYMENT")
             window.open(data.data, "_blank")
          } else {
            this.setState({
              isloading: false
            })
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      data
    );
  }
  render() {
    return (
      <Content>
        <div className="mi_main_div" style={{paddingTop:"40px"}}>
          <div className="mi_box_sd">
            <Row span={24}>
              <Col span={18}>
                <h4 className="mi_box_h4">Finance</h4>
              </Col>
              <Col span={6}>
                <img alt="example" style={{ height: '182px', marginTop: '-80px' }} src={img} />
              </Col>
            </Row>
          </div>
          <Collapse accordion={true}
            expandIconPosition='right'
            style={{marginLeft:"5px",marginRight:"10px"}}
            expandIcon={({ isActive }) => <Icon type="down" rotate={isActive ? 180 : 0} />}
          >
            <Panel header={<p className="mi_acc_header">Process Invoice</p>} key="1" >
              {this.state.isloading ?
                <div style={{ textAlign: 'center', display: 'absolute' }}>
                  <Spin size="large" />
                </div>
                : ""}
              <ManageInvoiceForm type="invoice" submitHandler={this.SubmitHandler} ></ManageInvoiceForm>
            </Panel>
            <Panel header={<p className="mi_acc_header">Process Payments</p>} key="2" >
              {this.state.isloading ?
                <div style={{ textAlign: 'center', display: 'absolute' }}>
                  <Spin size="large" />
                </div>
                : ""}
              <ManageInvoiceForm type="payment" submitHandler={this.SubmitHandler}></ManageInvoiceForm>
            </Panel>
            <Panel header={<p className="mi_acc_header">Monthly Reconciliation</p>} key="3" >
              {this.state.isloading ?
                <div style={{ textAlign: 'center', display: 'absolute' }}>
                  <Spin size="large" />
                </div>
                : ""}
              <ManageInvoiceForm type="reconciliation" submitHandler={this.SubmitHandler}></ManageInvoiceForm>
            </Panel>
          </Collapse>
        </div>
      </Content>
    );
  }
}
export default Finance;
